webpackJsonp([7],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ELMENU_SWITCH = exports.ELMENU_SWITCH = 'ELMENU_SWITCH';
var HEADERNAV_SWITCH = exports.HEADERNAV_SWITCH = 'HEADERNAV_SWITCH';

var USER_LOGIN_SUCCESS = exports.USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
var USER_OUT_LOGIN = exports.USER_OUT_LOGIN = 'USER_OUT_LOGIN';

var COM_LOADING_STATUS = exports.COM_LOADING_STATUS = 'COM_LOADING_STATUS';

var GET_NEWS_LIST_SUCCESS = exports.GET_NEWS_LIST_SUCCESS = 'GET_NEWS_LIST_SUCCESS';
var UPDATE_NEWS_DATA = exports.UPDATE_NEWS_DATA = 'UPDATE_NEWS_DATA';
var UPDATE_NEWS_CONTENT = exports.UPDATE_NEWS_CONTENT = 'UPDATE_NEWS_CONTENT';
var ADD_NEWS_CONTENT = exports.ADD_NEWS_CONTENT = 'ADD_NEWS_CONTENT';
var GET_NEWS_LABELS_SUCCESS = exports.GET_NEWS_LABELS_SUCCESS = 'GET_NEWS_LABELS_SUCCESS';
var ADD_NEWS_DATA_DONE = exports.ADD_NEWS_DATA_DONE = 'ADD_NEWS_DATA_DONE';
var GET_PRESS_LIST_SUCCESS = exports.GET_PRESS_LIST_SUCCESS = 'GET_PRESS_LIST_SUCCESS';
var APPID_LOGIN_SUCCESS = exports.APPID_LOGIN_SUCCESS = 'APPID_LOGIN_SUCCESS';
var GET_AUDIT_LIST_SUCCESS = exports.GET_AUDIT_LIST_SUCCESS = 'GET_AUDIT_LIST_SUCCESS';
var GET_CONSOLE_NEWS_LIST = exports.GET_CONSOLE_NEWS_LIST = 'GET_CONSOLE_NEWS_LIST';
var GET_NEWS_STATIS_LIST = exports.GET_NEWS_STATIS_LIST = 'GET_NEWS_STATIS_LIST';
var GET_CONSOLE_EVENT_LIST = exports.GET_CONSOLE_EVENT_LIST = 'GET_CONSOLE_EVENT_LIST';
var GET_CONSOLE_API_LIST = exports.GET_CONSOLE_API_LIST = 'GET_CONSOLE_API_LIST';
var GET_LABELS_LIST = exports.GET_LABELS_LIST = 'GET_LABELS_LIST';
var ADD_CONSOLE_DATA_DONE = exports.ADD_CONSOLE_DATA_DONE = 'ADD_CONSOLE_DATA_DONE';
var GET_JOKE_LIST_DEFAULT = exports.GET_JOKE_LIST_DEFAULT = 'GET_JOKE_LIST_DEFAULT';
var GET_JOKE_LIST_SEARCH = exports.GET_JOKE_LIST_SEARCH = 'GET_JOKE_LIST_SEARCH';
var GET_INTERLUDE_LIST = exports.GET_INTERLUDE_LIST = 'GET_INTERLUDE_LIST';
var SET_INTERLUDE_URL = exports.SET_INTERLUDE_URL = 'SET_INTERLUDE_URL';
var SET_CURRENT_INDEX = exports.SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';
var SET_AUTOPLAY = exports.SET_AUTOPLAY = 'SET_AUTOPLAY';

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(269);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _com = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COM_LOGIN = function COM_LOGIN() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 277));
};

var COM_PRESS_INDEX = function COM_PRESS_INDEX() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
};
var COM_PRESS_LIST = function COM_PRESS_LIST() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 278));
};
var COM_PRESS_SEARCH = function COM_PRESS_SEARCH() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 280));
};
var COM_PRESS_REVIEW = function COM_PRESS_REVIEW() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 279));
};

var COM_JOKE = function COM_JOKE() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 276));
};

var COM_404 = function COM_404() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 275));
};

_vue2.default.use(_vueRouter2.default);

var routes = [{
    name: 'home',
    path: (0, _com.routeMap)('/'),
    redirect: (0, _com.routeMap)('/press')
}, {
    name: 'login',
    path: (0, _com.routeMap)('/login'),
    component: COM_LOGIN }, {
    name: 'press',
    path: (0, _com.routeMap)('/press'),
    redirect: (0, _com.routeMap)('/press/list'),
    component: __webpack_require__(108),
    children: [{
        name: 'presslist',
        path: 'list',
        component: COM_PRESS_LIST }, {
        name: 'presssearch',
        path: 'search',
        component: COM_PRESS_SEARCH }, {
        name: 'pressreview',
        path: 'review',
        component: COM_PRESS_REVIEW }]
}, {
    name: 'joke',
    path: (0, _com.routeMap)('/joke/list'),
    component: COM_JOKE
}, {
    name: 'notfound',
    path: (0, _com.routeMap)('/404'),
    component: COM_404 }, {
    path: '*',
    redirect: (0, _com.routeMap)('/404')
}];

var router = new _vueRouter2.default({
    mode: 'history',
    base: __dirname,
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: routes
});

exports.default = router;
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(69);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(28);

var _querystring = __webpack_require__(261);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    apiCommunication: function apiCommunication(apiname, param, cb, errcb) {
        var params = param;
        var host = _config.CONSOLE_HOST;
        console.debug("apiCommunication> host:%o, apiname:%o, param:%o, cb:%o, errcb:%o", _config.API_HOST, apiname, param, cb, errcb);

        if (apiname) {
            var apinameArr = apiname.split('/');
            if (apinameArr[apinameArr.length - 2] == 'news' || apinameArr[apinameArr.length - 2] === 'console' || apinameArr[apinameArr.length - 2] === 'label' || apinameArr[apinameArr.length - 2] === 'user' && apinameArr[apinameArr.length - 1] !== 'login') {
                params = (0, _config.setParams)(param);
                console.debug("apiCommunication> params:%o", params);
            } else if (apinameArr[apinameArr.length - 2] == 'press') {
                host = _config.API_HOST;
                console.debug("apiCommunication> host:%o", host);
            } else if (apinameArr[apinameArr.length - 2] == 'joke' || apinameArr[apinameArr.length - 2] == 'interlude') {
                host = '//59.110.240.142:8082';
            }
        }

        _axios2.default.post(host + apiname, _querystring2.default.stringify(params)).then(function (response) {
            console.debug("apiCommunication> response:%o", response);

            if (typeof cb === 'function') {
                cb(response);
            }
        });
    }
};

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(254);

exports.default = {
  name: 'ibroadcast'
};

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(73);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(255);

var _com = __webpack_require__(9);

var _config = __webpack_require__(28);

var _vuex = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['type'],
  data: function data() {
    return {
      activeIndex: '',
      page: 1,
      limit: 10,
      clientid: 1,

      dialogTableVisible: false,
      dialogTableLoading: true,
      activeName: "first",

      setOption: _config.headerOption
    };
  },
  created: function created() {
    this.$store.dispatch('headernavSwitch', this.type);
    console.info("path:%o, params:%o, query:%o", this.$store.state.route.path, this.$store.state.route.params, this.$store.state.route.query);
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    getAccount: 'getAccount',
    getToken: 'getToken',
    getRole: 'getRole',
    getAppid: 'getAppid',
    getAccesstoken: 'getAccesstoken',
    newstats: 'newstats',
    newstatstotal: 'newstatstotal'
  }), {
    headernav: function headernav() {
      return this.$store.getters.headernav;
    },
    account: function account() {
      return this.$store.getters.getAccount;
    },
    keypath: function keypath() {
      var patarry = this.$store.state.route.path.split('/');

      return patarry[patarry.length - 1];
    },
    headurl: function headurl() {},
    readMenuItemName: function readMenuItemName() {
      console.debug("readMenuItemName> newsType:%o", _config.newsType[this.activeIndex]);
      return _config.newsType[this.activeIndex] || '分类';
    },
    ComputerRouterName: function ComputerRouterName() {
      return _config.routerType[this.type] || '班玛资讯';
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    getEditorData: 'getEditorData',
    getPressData: 'getPressData',
    getNewsData: 'getNewsData',
    updateLoadingStatus: 'updateLoadingStatus',
    getNewStatis: 'getNewStatis',
    updateNewsContent: 'updateNewsContent'
  }), {
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    handleAddClick: function handleAddClick() {
      var param = {};
      this.updateNewsContent(param);
      this.$router.push({ path: (0, _com.routeMap)('/ieditor/edit') });
    },
    handlelogoclick: function handlelogoclick(type) {
      console.debug("handlelogoclick> type:%o", type);


      if (type === 'press') {
        this.activeIndex = '';
        this.$router.push({ path: (0, _com.routeMap)('/' + type + '/list'), query: { page: 1 } });
      } else {
          this.$router.push({ path: (0, _com.routeMap)('/' + type + '/list'), query: { page: 1 } });
        }
    },
    GetRequest: function GetRequest(url) {
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1).split('?');
        console.debug("GetRequest> str:%o", str);
        var strs = str[str.length - 1].split("&");
        console.debug("GetRequest> strs:%o", strs);
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    handleSelect: function handleSelect(key, keyPath) {
      var _this = this;

      console.debug("handleSelect> key:%o, keyPath:%o, activeIndex:%o", key, keyPath, this.activeIndex);

      if (this.type === 'ieditor') {
        var request = new Object();
        request = this.GetRequest(key);
        var type = request['type'] || '';
        console.debug("handleSelect> type:%o", type);

        var param = {
          state: 1,
          category: type,
          page: this.page,
          limit: this.limit
        };
        console.debug("handleSelect> getNewsData> param:%o", param);

        this.updateLoadingStatus(true);
        this.getNewsData(param).then(function (resp) {
          _this.updateLoadingStatus(false);
          console.debug("handleSelect> getNewsData> resp:%o", resp);
        }, function (err) {
          _this.updateLoadingStatus(false);
          console.error("handleSelect> getNewsData> err:%o", err);
        });
        this.activeIndex = type;
      }
    },
    genData: function genData() {
      var d = [];
      var len = 0;

      var value;
      while (len++ < 50) {
        d.push([new Date(2014, 9, 1, 0, len * 10000), (Math.random() * 30).toFixed(2) - 0]);
      }
      console.debug("genData> d:%o", d);
      return d;
    },
    showDiag: function showDiag() {
      var that = this;
      that.activeName = 'first';
      that.dialogTableVisible = true;
      var param = {};
      console.debug("created> getNewStatis> param:%o", param);

      that.dialogTableLoading = true;
      that.getNewStatis(param).then(function (resp) {
        that.dialogTableLoading = false;
        console.debug("created> getNewStatis> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else {

          var _data = resp.data.process,
              _legendData = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(_data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              var serialData = [];

              var tarr = item.time.split(":");
              var pt = new Date().setHours(tarr[0], tarr[1]);

              serialData.push(pt);
              serialData.push(item.count);

              _legendData.push(serialData);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          for (var i = 1; i < _legendData.length; i++) {
            var key = _legendData[i];
            var j = i - 1;
            while (j >= 0 && _legendData[j][0] > key[0]) {
              _legendData[j + 1] = _legendData[j];
              j--;
            }
            _legendData[j + 1] = key;
          }

          that.setOption.series[0].data = _legendData;
          that.setOption.dataZoom.start = resp.data.total < 3 ? 0 : 16;
          if (resp.data.total !== 0) {
            that.setOption.title.text = '新闻产出分布';
            that.setOption.title.subtext = '总数:' + resp.data.total;
          } else {
            that.setOption.title.text = '暂无数据';
            that.setOption.title.subtext = '';
          }

          var myChart = echarts.init(document.getElementById('salesTime'));
          console.debug("getNewStatis> setOption:%o", that.setOption);
          myChart.setOption(that.setOption);
        }
      });
    },
    handleCommand: function handleCommand(command) {
      switch (command) {
        case 'workstats':
          break;
        case 'outLogin':
          this.$store.dispatch('outLogin');
          this.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: this.type } });
          break;
      }
    }
  })
};

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headernav = __webpack_require__(115);

var _headernav2 = _interopRequireDefault(_headernav);

__webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    components: {
        headernav: _headernav2.default
    }
};

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(110);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(70);

var _store2 = _interopRequireDefault(_store);

var _elementUi = __webpack_require__(45);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _vuexRouterSync = __webpack_require__(113);

var _ibroadcast = __webpack_require__(112);

var _ibroadcast2 = _interopRequireDefault(_ibroadcast);

var _axios = __webpack_require__(69);

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__(111);

var _com = __webpack_require__(9);

var _config = __webpack_require__(28);

var _cryptoJs = __webpack_require__(71);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.info("API_HOST:'%s'", _config.API_HOST);

if (_config.MOCK_DEBUG) {}

_vue2.default.use(_elementUi2.default);

_router2.default.beforeEach(function (to, from, next) {
    console.debug("beforeEach> to:%o", to);
    var token = _store2.default.getters.getToken || _store2.default.getters.getAccesstoken;
    var role = _store2.default.getters.getRole || '';
    console.debug("beforeEach> token:%o, role:%o", token, role);
    if (token != null && to.path == (0, _com.routeMap)('/login')) {
        next((0, _com.routeMap)('/'));
    }

    var wxtoken = to.query.token || '';
    var pageType = to.query.type || '';
    var appid = to.query.appid || '';
    console.log(pageType);

    var wxLogin = {
        name: '',
        password: ''
    };
    if (appid && wxtoken && pageType === 'press') {
        var exp = new Date();
        var timestamp = Math.round(exp.getTime() / 60000);

        var tempstr = 'wxgzh' + 'wxgzh171122' + timestamp;
        var tmeptoken = _cryptoJs2.default.MD5(tempstr).toString();

        var finaltoken = (timestamp + tmeptoken).toUpperCase();

        wxLogin.name = appid;
        wxLogin.password = finaltoken;
        _store2.default.dispatch('TokenLogin', wxLogin);
        next((0, _com.routeMap)('/press'));
    } else if (appid && wxtoken && pageType === 'joke') {
        var exp = new Date();
        var _timestamp = Math.round(exp.getTime() / 60000);

        var _tempstr = 'wxgzh' + 'wxgzh171122' + _timestamp;
        var _tmeptoken = _cryptoJs2.default.MD5(_tempstr).toString();

        var _finaltoken = (_timestamp + _tmeptoken).toUpperCase();

        wxLogin.name = appid;
        wxLogin.password = _finaltoken;
        _store2.default.dispatch('TokenLogin', wxLogin);
        next((0, _com.routeMap)('/joke/list'));
    }

    if (token === null && to.path !== (0, _com.routeMap)('/login') && to.path !== (0, _com.routeMap)('/404')) {
        next({
            path: (0, _com.routeMap)('/login'),
            query: to.query
        });
    } else {
        next();
    }
});

_vue2.default.filter('enableStatus', function (value) {
    return value === '1' ? '启用中' : '已禁用';
});

_axios2.default.interceptors.response.use(function (response) {
    console.debug("axios.interceptors> response:%o", response);
    if (response.status === 200) {
        var request = response.request || { responseURL: '' };
        var urlarr = request.responseURL.split('/') || [];
        console.debug("axios.interceptors> request:%o, urlarr:%o", request, urlarr);
        if (parseInt(response.data.code) === 9 && urlarr[urlarr.length - 1] !== 'login') {
            console.warn("token过期，执行退出登录");
            _elementUi.MessageBox.alert("token过期，执行退出登录", { confirmButtonText: '确定', type: 'error' });
            _store2.default.dispatch('outLogin');

            var type = urlarr[urlarr.length - 2];
            vm.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: type } });
        } else {
            return response.data;
        }
    } else {
        _elementUi.MessageBox.alert(response.data.msg, { confirmButtonText: '确定', type: 'error' });
    }
}, function (error) {
    console.debug("axios.interceptors> error:%o", error);
    _elementUi.MessageBox.alert('接口通讯失败，请尝试刷新页面或者重新登录。如果还是存在问题，请联系管理员', '系统通知', { confirmButtonText: '确定', type: 'error' });
    return _promise2.default.reject(error);
});

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

var vm = new _vue2.default({
    el: '#ibroadcast',
    router: _router2.default,
    store: _store2.default,
    render: function render(h) {
        return h(_ibroadcast2.default);
    }
});

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    auditdata: {},
    audittotal: 0
};

var getters = {
    auditdata: function auditdata(state) {
        return state.auditdata;
    },
    audittotal: function audittotal(state) {
        return state.audittotal;
    }
};

var actions = {
    getAuditData: function getAuditData(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        console.debug("getAuditData> param:%o", param);
        _api2.default.apiCommunication('/api/news/list', param, function (response) {
            console.debug("getAuditData /api/news/list> response:%o", response);

            commit(types.GET_AUDIT_LIST_SUCCESS, { response: response });
        });
    },
    getAuditDataII: function getAuditDataII(_ref2, param) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        console.debug("getAuditDataII> param:%o", param);
        var response = {};
        response.code = 1;
        commit(types.GET_AUDIT_LIST_SUCCESS, { response: response });

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/list', param, function (response) {
                console.debug("getAuditDataII ok response:%o", response);
                commit(types.GET_AUDIT_LIST_SUCCESS, { response: response });
                resolve(response);
            }, function (err) {
                console.error("getAuditDataII err:%o", err);

                reject(err);
            });
        });
    }
};

var mutations = (0, _defineProperty3.default)({}, types.GET_AUDIT_LIST_SUCCESS, function (state, _ref3) {
    var response = _ref3.response;

    var _data = {};
    var total = 0;

    if (response.code === 0) {
        _data = response.data.news;
        total = Number(response.data.total);
    }
    state.auditdata = _data;
    state.audittotal = total;
});

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _package = __webpack_require__(272);

var pi = _interopRequireWildcard(_package);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VERSION = pi.version;

var state = {
    appVer: VERSION,
    loadingStatus: false
};

var getters = {
    getAppVer: function getAppVer(state) {
        return state.appVer;
    },
    getLoadingStatus: function getLoadingStatus(state) {
        return state.loadingStatus;
    }
};

var actions = {
    updateLoadingStatus: function updateLoadingStatus(_ref, loading_status) {
        var commit = _ref.commit;

        commit(types.COM_LOADING_STATUS, { loading_status: loading_status });
    }
};

var mutations = (0, _defineProperty3.default)({}, types.COM_LOADING_STATUS, function (state, _ref2) {
    var loading_status = _ref2.loading_status;

    var status = false;
    console.debug("COM_LOADING_STATUS> loading_status:%o", loading_status);
    if (loading_status === true) {
        status = true;
    }
    state.loadingStatus = status;
});

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _mutations;

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    newsdata: {},
    newstotal: 0,
    newContent: {},
    userlist: []
};

var getters = {
    newsdata: function newsdata(state) {
        return state.newsdata;
    },
    newstotal: function newstotal(state) {
        return state.newstotal;
    },
    newContent: function newContent(state) {
        return state.newContent;
    },
    userlist: function userlist(state) {
        return state.userlist;
    }
};

var actions = {
    getEditorData: function getEditorData(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        console.debug("getEditorData> param:%o, state:%o, rootState:%o", param, state, rootState);
        _api2.default.apiCommunication('/api/news/list', param, function (response) {
            console.debug("/api/news/list> response:%o", response);

            commit(types.GET_NEWS_LIST_SUCCESS, { response: response });
        });
    },
    getNewsData: function getNewsData(_ref2, param) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        console.debug("getNewsData> param:%o", param);
        commit(types.GET_NEWS_LIST_SUCCESS, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/list', param, function (response) {
                console.debug("getNewsData ok response:%o", response);
                commit(types.GET_NEWS_LIST_SUCCESS, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getNewsData err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateNewsData: function updateNewsData(_ref3, param) {
        var commit = _ref3.commit;

        console.debug("updateNewsData> param:%o", param);
        var response = {};
        response.code = 0;
        commit(types.UPDATE_NEWS_DATA, { response: response, param: param });
    },
    updateNewsDataDone: function updateNewsDataDone(_ref4, param) {
        var commit = _ref4.commit;

        console.debug("updateNewsDataDone> param:%o", param);
        commit(types.ADD_NEWS_DATA_DONE, { param: param });
    },
    addNewsContent: function addNewsContent(_ref5, param) {
        var commit = _ref5.commit;

        console.debug("addNewsContent> param:%o", param);

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/add', param, function (response) {

                commit(types.ADD_NEWS_CONTENT, { response: response, param: param });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    editNewsContent: function editNewsContent(_ref6, param) {
        var commit = _ref6.commit;

        console.debug("editNewsContent> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/edit', param, function (response) {
                console.debug("editNewsContent response:%o", response);


                commit(types.UPDATE_NEWS_CONTENT, { response: response, param: param });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateNewsContent: function updateNewsContent(_ref7, param) {
        var commit = _ref7.commit;

        console.debug("updateNewsContent> param:%o", param);
        var response = {};

        response.code = 0;
        commit(types.UPDATE_NEWS_CONTENT, { response: response, param: param });
    },
    transferNewsState: function transferNewsState(_ref8, param) {
        var commit = _ref8.commit;

        console.debug("transferNewsState> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/transfer', param, function (resp) {
                console.debug("transferNewsState resp:%o", resp);
                if (typeof resolve === 'function') {
                    resolve(resp);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getNewLables: function getNewLables(_ref9, param) {
        var commit = _ref9.commit;

        console.debug("getNewLables> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/label', param, function (resp) {
                console.debug("getNewLables resp:%o", resp);
                if (typeof resolve === 'function') {
                    resolve(resp);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getUserList: function getUserList(_ref10, param) {
        var commit = _ref10.commit;

        console.debug("getUserList> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/user/list', param, function (resp) {
                console.debug("getUserList resp:%o", resp);
                if (typeof resolve === 'function') {
                    resolve(resp);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.GET_NEWS_LIST_SUCCESS, function (state, _ref11) {
    var response = _ref11.response;

    console.debug("GET_NEWS_LIST_SUCCESS> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.news;
        state.newstotal = Number(response.data.total);
    }
    state.newsdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_NEWS_DATA, function (state, _ref12) {
    var response = _ref12.response,
        param = _ref12.param;

    console.debug("UPDATE_NEWS_DATA> response:%o, param:%o", response, param);
    var _data = {};
    if (response.code === 0) {
        _data = param;
        state.newsdata = _data;
    }
}), (0, _defineProperty3.default)(_mutations, types.ADD_NEWS_DATA_DONE, function (state, _ref13) {
    var param = _ref13.param;

    console.debug("ADD_NEWS_DATA_DONE> param:%o", param);
    if (param && param.id && param.done) {
        console.debug('lable/update> before newsdata:%o', state.newsdata);
        state.newsdata.filter(function (u) {
            if (u.id === param.id) {
                u.done = param.done;
                return true;
            }
        });
        console.debug("label/update> after newsdata:%o", state.newsdata);
    }
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_NEWS_CONTENT, function (state, _ref14) {
    var response = _ref14.response,
        param = _ref14.param;

    console.debug("UPDATE_NEWS_CONTENT> response:%o, param:%o", response, param);
    var _data = {};
    if (response.code === 0) {
        _data = param;

        state.newContent = _data;
    }
}), (0, _defineProperty3.default)(_mutations, types.ADD_NEWS_CONTENT, function (state, _ref15) {
    var response = _ref15.response,
        param = _ref15.param;

    console.debug("ADD_NEWS_CONTENT> response:%o, param:%o", response, param);
    var _data = {};
    if (response.code === 0) {
        _data = param;
        _data.id = response.data.newsId;
    }
    state.newContent = _data;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {};

var getters = {};

var actions = {};

var mutations = {};

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = __webpack_require__(73);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mutations;

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    jokedata: {},
    joketotalItem: 0,
    interlude: [],
    interludeUrl: null,
    currentIndex: null,
    autoplay: false
};

var getters = {
    jokeData: function jokeData(state) {
        return state.jokedata;
    },
    jokeTotalItem: function jokeTotalItem(state) {
        return state.joketotalItem;
    },
    interlude: function interlude(state) {
        return state.interlude;
    },
    interludeUrl: function interludeUrl(state) {
        return state.interludeUrl;
    },
    currentIndex: function currentIndex(state) {
        return state.currentIndex;
    },
    autoplay: function autoplay(state) {
        return state.autoplay;
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.GET_JOKE_LIST_DEFAULT, function (state, _ref) {
    var response = _ref.response;

    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.joke;
        if (_data) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(_data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var v = _step.value;

                    var t = v.tags;
                    var t_1 = t.split('#').join(' / ');
                    v.tags = t_1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            state.joketotalItem = Number(response.data.total);
        }
    }
    state.jokedata = _data;
}), (0, _defineProperty3.default)(_mutations, types.GET_INTERLUDE_LIST, function (state, _ref2) {
    var response = _ref2.response;

    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.interlude;
    }
    state.interlude = _data;
}), (0, _defineProperty3.default)(_mutations, types.SET_INTERLUDE_URL, function (state, url) {
    state.interludeUrl = url;
    console.log(state.interludeUrl);
}), (0, _defineProperty3.default)(_mutations, types.SET_CURRENT_INDEX, function (state, index) {
    state.currentIndex = index;
}), (0, _defineProperty3.default)(_mutations, types.SET_AUTOPLAY, function (state, boolean) {
    state.autoplay = boolean;
}), _mutations);

var actions = {
    getJokeList: function getJokeList(_ref3, param) {
        var commit = _ref3.commit,
            state = _ref3.state,
            rootState = _ref3.rootState;

        console.debug("getJokeList> param:%o", param);
        commit(types.GET_JOKE_LIST_DEFAULT, {});

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/joke/list', param, function (response) {
                console.debug("getJokeList ok response:%o", response);
                commit(types.GET_JOKE_LIST_DEFAULT, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getJokeList err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getInterludeList: function getInterludeList(_ref4, param) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootState = _ref4.rootState;

        console.debug("getInterludeList> param:%o", param);
        commit(types.GET_INTERLUDE_LIST, {});

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/interlude/list', param, function (response) {
                console.debug("getInterludeList ok response:%o", response);
                commit(types.GET_INTERLUDE_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getInterludeList err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    setInterludeUrl: function setInterludeUrl(_ref5, url) {
        var commit = _ref5.commit,
            state = _ref5.state,
            rootState = _ref5.rootState;

        console.debug("setInterludeList> url:%o", url);
        commit(types.SET_INTERLUDE_URL, url);
    },
    setCurrentIndex: function setCurrentIndex(_ref6, index) {
        var commit = _ref6.commit,
            state = _ref6.state,
            rootState = _ref6.rootState;

        console.debug("setcurrentIndex> index:%o", index);
        commit(types.SET_CURRENT_INDEX, index);
    },
    setAutoPlay: function setAutoPlay(_ref7, boolean) {
        var commit = _ref7.commit,
            state = _ref7.state,
            rootState = _ref7.rootState;

        console.debug("setAutoPlay> autoplay:%o", boolean);
        commit(types.SET_AUTOPLAY, boolean);
    }
};

exports.default = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _reactCookie = __webpack_require__(262);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _elementUi = __webpack_require__(45);

var _config = __webpack_require__(28);

var _com = __webpack_require__(9);

var _cryptoJs = __webpack_require__(71);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    token: _reactCookie2.default.load('ibroadcasttoken') || null,
    account: _reactCookie2.default.load('ibroadcastaccount') || null,
    role: _reactCookie2.default.load('ibroadcastrole') || null,
    osspolicy: _reactCookie2.default.load('ibroadcastosspolicy') || null,
    osskeyid: _reactCookie2.default.load('ibroadcastosskeyid') || null,
    osssign: _reactCookie2.default.load('ibroadcastosssign') || null,

    appid: _reactCookie2.default.load('ibroadcastappid') || null,
    accesstoken: _reactCookie2.default.load('ibroadcastaccesstoken') || null
};

var getters = {
    getToken: function getToken(state) {
        return state.token;
    },
    getAccount: function getAccount(state) {
        return state.account;
    },
    getRole: function getRole(state) {
        return state.role;
    },
    getOsspolicy: function getOsspolicy(state) {
        return state.osspolicy;
    },
    getOsskeyid: function getOsskeyid(state) {
        return state.osskeyid;
    },
    getOsssign: function getOsssign(state) {
        return state.osssign;
    },

    getAppid: function getAppid(state) {
        return state.appid;
    },
    getAccesstoken: function getAccesstoken(state) {
        return state.accesstoken;
    }
};

var actions = {
    onLogin: function onLogin(_ref, that) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        var param = that.form;
        _api2.default.apiCommunication('/api/user/login', param, function (response) {
            console.debug("onLogin> param:%o, response:%o", param, response);
            if (response.code !== 0) {
                _elementUi.MessageBox.alert('\u767B\u5F55\u5931\u8D25\uFF0C' + response.msg, '系统通知', { confirmButtonText: '确定', type: 'error' });
                return false;
            }

            var exp = new Date();
            exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000);

            _reactCookie2.default.save('ibroadcasttoken', response.data.token, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastaccount', param.name, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastrole', response.data.role, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastosspolicy', response.data.osspolicy, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastosskeyid', response.data.osskeyid, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastosssign', response.data.osssign, {
                path: '/',
                expires: exp
            });

            console.debug("onLogin> param:%o", param);
            commit(types.USER_LOGIN_SUCCESS, { response: response, param: param });

            var type = null;
            if (state.role) {
                type = _config.roleType[state.role];
            } else {
                type = rootState.route.query.type || '';
            }
            that.$router.push({ path: (0, _com.routeMap)('/' + type) });
        });
    },
    AppIdLogin: function AppIdLogin(_ref2, that) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        var param = {};
        param.appid = that.form.name;
        var appsecret = that.form.password;

        var exp = new Date();

        var timestamp = Math.round(exp.getTime() / 60000);
        console.debug("timestamp:%o", timestamp);
        var tempstr = param.appid + appsecret + timestamp;
        var tmeptoken = _cryptoJs2.default.MD5(tempstr).toString();
        console.debug("tempstr:%s, tmeptoken:%s", tempstr, tmeptoken);
        var accesstoken = (timestamp + tmeptoken).toUpperCase();
        console.debug("accesstoken:%o", accesstoken);
        param.accesstoken = accesstoken;
        console.debug("AppIdLogin> param:%o", param);

        exp.setTime(exp.getTime() + 1 * 2 * 60 * 60 * 1000);

        _reactCookie2.default.save('ibroadcastappid', param.appid, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccesstoken', param.accesstoken, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccount', param.appid, {
            path: '/',
            expires: exp
        });

        console.debug("AppIdLogin> param:%o", param);
        commit(types.APPID_LOGIN_SUCCESS, { param: param });
        var type = rootState.route.query.type || '';
        that.$router.push({ path: (0, _com.routeMap)('/' + type) });
    },
    TokenLogin: function TokenLogin(_ref3, that) {
        var commit = _ref3.commit,
            state = _ref3.state,
            rootState = _ref3.rootState;

        var param = {
            appid: that.name,
            accesstoken: that.password
        };
        console.debug("TokenLogin> param:%o", param);
        var exp = new Date();
        exp.setTime(exp.getTime() + 1 * 2 * 60 * 60 * 1000);

        _reactCookie2.default.save('ibroadcastappid', param.appid, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccesstoken', param.accesstoken, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccount', param.appid, {
            path: '/',
            expires: exp
        });

        console.debug("AppIdLogin> param:%o", param);
        commit(types.APPID_LOGIN_SUCCESS, { param: param });
    },
    outLogin: function outLogin(_ref4) {
        var commit = _ref4.commit;

        _reactCookie2.default.remove('ibroadcasttoken', { path: '/' });
        _reactCookie2.default.remove('ibroadcastaccount', { path: '/' });
        _reactCookie2.default.remove('ibroadcastrole', { path: '/' });
        _reactCookie2.default.remove('ibroadcastosspolicy', { path: '/' });
        _reactCookie2.default.remove('ibroadcastosskeyid', { path: '/' });
        _reactCookie2.default.remove('ibroadcastosssign', { path: '/' });
        _reactCookie2.default.remove('ibroadcastappid', { path: '/' });
        _reactCookie2.default.remove('ibroadcastaccesstoken', { path: '/' });

        commit(types.USER_OUT_LOGIN);
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.USER_LOGIN_SUCCESS, function (state, _ref5) {
    var response = _ref5.response,
        param = _ref5.param;

    console.debug("USER_LOGIN_SUCCESS> response:%o, param:%o", response, param);
    state.account = param.name;
    state.token = response.data.token;
    state.role = response.data.role;
    state.osspolicy = response.data.osspolicy;
    state.osskeyid = response.data.osskeyid;
    state.osssign = response.data.osssign;
}), (0, _defineProperty3.default)(_mutations, types.APPID_LOGIN_SUCCESS, function (state, _ref6) {
    var param = _ref6.param;

    console.debug("APPID_LOGIN_SUCCESS> param:%o", param);
    state.appid = param.appid;
    state.accesstoken = param.accesstoken;
    state.account = param.appid;
}), (0, _defineProperty3.default)(_mutations, types.USER_OUT_LOGIN, function (state) {
    state.account = null;
    state.token = null;
    state.role = null;
    state.osspolicy = null;
    state.osskeyid = null;
    state.osssign = null;
    state.appid = null;
    state.accesstoken = null;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    headernav: [],
    elmenu: []
};

var getters = {
    headernav: function headernav(state) {
        return state.headernav;
    },
    elmenu: function elmenu(state) {
        return state.elmenu;
    }
};

var datamentdata = [{
    name: '管理',
    url: '/productment',
    child: [{
        name: '列表',
        url: '/datament/productmgt'
    }]
}];

var ieditordata = [{
    name: '分类',
    url: (0, _com.routeMap)('/ieditor'),
    type: 'ieditor',
    child: [{
        name: '时政',
        url: (0, _com.routeMap)('/ieditor/list?type=2')
    }, {
        name: '社会',
        url: (0, _com.routeMap)('/ieditor/list?type=3')
    }, {
        name: '国际',
        url: (0, _com.routeMap)('/ieditor/list?type=4')
    }, {
        name: '科技',
        url: (0, _com.routeMap)('/ieditor/list?type=5')
    }, {
        name: '财经',
        url: (0, _com.routeMap)('/ieditor/list?type=6')
    }, {
        name: '娱乐',
        url: (0, _com.routeMap)('/ieditor/list?type=7')
    }, {
        name: '体育',
        url: (0, _com.routeMap)('/ieditor/list?type=8')
    }, {
        name: '军事',
        url: (0, _com.routeMap)('/ieditor/list?type=9')
    }, {
        name: '时尚',
        url: (0, _com.routeMap)('/ieditor/list?type=10')
    }]
}];

var pressdata = [{
    name: '列表',
    url: (0, _com.routeMap)('/press/list'),
    type: 'list'
}, {
    name: '搜索',
    url: (0, _com.routeMap)('/press/search'),
    type: 'search'
}];

var statsdata = [{
    name: '新闻列表',
    url: (0, _com.routeMap)('/stats/list'),
    type: 'list'
}, {
    name: '接口统计',
    url: (0, _com.routeMap)('/stats/interface'),
    type: 'interface'
}, {
    name: '事件统计',
    url: (0, _com.routeMap)('/stats/events'),
    type: 'event'
}, {
    name: '标签管理',
    url: (0, _com.routeMap)('/stats/labels'),
    type: 'labels'
}];

var actions = {
    headernavSwitch: function headernavSwitch(_ref, type) {
        var commit = _ref.commit;


        var data = void 0;
        switch (type) {
            case 'ieditor':
                break;
            case 'irecord':
                break;
            case 'press':
                data = pressdata;
                break;
            case 'audit':
                break;
            case 'stats':
                data = statsdata;
                break;
            case 'joke':
                break;

        }

        commit(types.HEADERNAV_SWITCH, { data: data });
    },
    elmenuSwitch: function elmenuSwitch(_ref2, type) {
        var commit = _ref2.commit;

        var data = void 0;
        switch (type) {
            default:
                data = datamentdata;
                break;
        }
        commit(types.ELMENU_SWITCH, { data: data });
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.HEADERNAV_SWITCH, function (state, _ref3) {
    var data = _ref3.data;

    state.headernav = data;
}), (0, _defineProperty3.default)(_mutations, types.ELMENU_SWITCH, function (state, _ref4) {
    var data = _ref4.data;

    state.elmenu = data;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    pressdata: {},
    presstotal: 0
};

var getters = {
    pressdata: function pressdata(state) {
        return state.pressdata;
    },
    presstotal: function presstotal(state) {
        return state.presstotal;
    }
};

var actions = {
    getPressData: function getPressData(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        console.debug("getPressData> param:%o", param);
        commit(types.GET_PRESS_LIST_SUCCESS, {});

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/press/list', param, function (response) {
                console.debug("getPressData ok response:%o", response);
                commit(types.GET_PRESS_LIST_SUCCESS, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getPressData err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    searchPressData: function searchPressData(_ref2, param) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        console.debug("searchPressData> param:%o", param);
        commit(types.GET_PRESS_LIST_SUCCESS, {});

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/press/search', param, function (response) {
                console.debug("searchPressData ok response:%o", response);
                commit(types.GET_PRESS_LIST_SUCCESS, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("searchPressData err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    }
};

var mutations = (0, _defineProperty3.default)({}, types.GET_PRESS_LIST_SUCCESS, function (state, _ref3) {
    var response = _ref3.response;

    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.news;
        state.presstotal = Number(response.data.total);
    }
    state.pressdata = _data;
});

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _mutations;

var _api = __webpack_require__(12);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    statsdata: {},
    statstotal: 0,
    newstats: {},
    newstatstotal: 0,
    eventdata: {},
    eventtotal: 0,
    apidata: null,
    appidlist: null,
    apitotal: null,
    labellist: null,
    labeltotal: null
};

var getters = {
    statsdata: function statsdata(state) {
        return state.statsdata;
    },
    statstotal: function statstotal(state) {
        return state.statstotal;
    },
    newstats: function newstats(state) {
        return state.newstats;
    },
    newstatstotal: function newstatstotal(state) {
        return state.newstatstotal;
    },
    eventdata: function eventdata(state) {
        return state.eventdata;
    },
    eventtotal: function eventtotal(state) {
        return state.eventtotal;
    },
    apidata: function apidata(state) {
        return state.apidata;
    },
    appidlist: function appidlist(state) {
        return state.appidlist;
    },
    apitotal: function apitotal(state) {
        return state.apitotal;
    },
    labellist: function labellist(state) {
        return state.labellist;
    },
    labeltotal: function labeltotal(state) {
        return state.labeltotal;
    }
};

var actions = {
    getConsoleNews: function getConsoleNews(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        console.debug("getConsoleNews> param:%o", param);
        commit(types.GET_CONSOLE_NEWS_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/console/news', param, function (response) {
                console.debug("getConsoleNews ok response:%o", response);
                commit(types.GET_CONSOLE_NEWS_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getConsoleNews err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateConsoleNewsDone: function updateConsoleNewsDone(_ref2, param) {
        var commit = _ref2.commit;

        console.debug("updateConsoleNewsDone> param:%o", param);
        commit(types.ADD_CONSOLE_DATA_DONE, { param: param });
    },
    getNewStatis: function getNewStatis(_ref3, param) {
        var commit = _ref3.commit,
            state = _ref3.state,
            rootState = _ref3.rootState;

        console.debug("getNewStatis> param:%o", param);
        commit(types.GET_NEWS_STATIS_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/statistics', param, function (response) {
                console.debug("getNewStatis ok response:%o", response);
                commit(types.GET_NEWS_STATIS_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getNewStatis err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getConsoleEvent: function getConsoleEvent(_ref4, param) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootState = _ref4.rootState;

        console.debug("getConsoleEvent> param:%o", param);
        commit(types.GET_CONSOLE_EVENT_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/console/event', param, function (response) {
                console.debug("getConsoleEvent ok response:%o", response);
                commit(types.GET_CONSOLE_EVENT_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getConsoleEvent err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getConsoleApi: function getConsoleApi(_ref5, param) {
        var commit = _ref5.commit,
            state = _ref5.state,
            rootState = _ref5.rootState;

        console.debug("getConsoleApi> param:%o", param);
        commit(types.GET_CONSOLE_API_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/console/api', param, function (response) {
                console.debug("getConsoleApi ok response:%o", response);
                commit(types.GET_CONSOLE_API_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getConsoleApi err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getLabelList: function getLabelList(_ref6, param) {
        var commit = _ref6.commit,
            state = _ref6.state,
            rootState = _ref6.rootState;

        console.debug("getLabelList> param:%o", param);
        commit(types.GET_LABELS_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/label/list', param, function (response) {
                console.debug("getLabelList ok response:%o", response);
                commit(types.GET_LABELS_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getLabelList err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateLabel: function updateLabel(_ref7, param) {
        var commit = _ref7.commit,
            state = _ref7.state,
            rootState = _ref7.rootState;

        console.debug("updateLabel> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/label/update', param, function (response) {
                console.debug("updateLabel ok response:%o", response);
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("updateLabel err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    delLabel: function delLabel(_ref8, param) {
        var commit = _ref8.commit,
            state = _ref8.state,
            rootState = _ref8.rootState;

        console.debug("delLabel> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/label/del', param, function (response) {
                console.debug("delLabel ok response:%o", response);
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("delLabel err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.GET_CONSOLE_NEWS_LIST, function (state, _ref9) {
    var response = _ref9.response;

    console.debug("GET_CONSOLE_NEWS_LIST> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.news;
        state.statstotal = Number(response.data.total);
    }
    state.statsdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.GET_NEWS_STATIS_LIST, function (state, _ref10) {
    var response = _ref10.response;

    console.debug("GET_NEWS_STATIS_LIST> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data;
        state.newstatstotal = Number(response.data.total);
    }
    state.newstats = _data;
}), (0, _defineProperty3.default)(_mutations, types.ADD_CONSOLE_DATA_DONE, function (state, _ref11) {
    var param = _ref11.param;

    console.debug("ADD_CONSOLE_DATA_DONE> param:%o", param);
    if (param && param.id && param.done) {
        state.statsdata.filter(function (u) {
            if (u.id === param.id) {
                u.done = param.done;
                return true;
            }
        });
    }
}), (0, _defineProperty3.default)(_mutations, types.GET_CONSOLE_EVENT_LIST, function (state, _ref12) {
    var response = _ref12.response;

    console.debug("GET_CONSOLE_EVENT_LIST> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.events;
        state.eventtotal = Number(response.data.total);
    }
    state.eventdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.GET_CONSOLE_API_LIST, function (state, _ref13) {
    var response = _ref13.response;

    console.debug("GET_CONSOLE_API_LIST> response:%o", response);
    var _apidata = {},
        _appidlist = [];
    if (response && response.code === 0) {
        _apidata = response.data.statistics;
        _appidlist = response.data.appidlist;
        state.apitotal = Number(response.data.total);
    }
    state.apidata = _apidata;
    state.appidlist = _appidlist;
}), (0, _defineProperty3.default)(_mutations, types.GET_LABELS_LIST, function (state, _ref14) {
    var response = _ref14.response;

    console.debug("GET_LABELS_LIST> response:%o", response);
    var _labellist = [];
    if (response && response.code === 0) {
        _labellist = response.data.label;
        state.labeltotal = Number(response.data.total);
    }
    state.labellist = _labellist;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "press"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "press"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itoolbar"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": "工作统计",
      "visible": _vm.dialogTableVisible,
      "modal-append-to-body": false,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "工作数据",
      "name": "first"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogTableLoading),
      expression: "dialogTableLoading"
    }],
    staticClass: "echarts-wrap",
    attrs: {
      "id": "salesTime",
      "element-loading-text": "拼命加载中..."
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "驳回信息",
      "name": "second"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogTableLoading),
      expression: "dialogTableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中...",
      "data": _vm.newstats.fallback,
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "标题"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.title))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "驳回原因"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.tip))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "prop": "time",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "标题",
      "prop": "title",
      "min-width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驳回原因",
      "prop": "tip",
      "min-width": "250"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false;
        _vm.dialogTableLoading = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false;
        _vm.dialogTableLoading = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "toolbar-nav",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "toolbar-log-box",
    attrs: {
      "xs": 6,
      "sm": 5,
      "md": 5,
      "lg": 3
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.handlelogoclick(_vm.type)
      }
    }
  }, [_c('img', {
    staticClass: "toolbar-logo",
    attrs: {
      "src": __webpack_require__(265)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fs-text",
    staticStyle: {
      "color": "#E5E9F2"
    }
  }, [_vm._v(" · " + _vm._s(_vm.ComputerRouterName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 13,
      "sm": 14,
      "md": 12,
      "lg": 8
    }
  }, [_c('el-menu', {
    staticClass: "toolbar-menu",
    attrs: {
      "theme": "dark",
      "default-active": _vm.activeIndex,
      "unique-opened": true,
      "mode": "horizontal",
      "router": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.headernav), function(item) {
    return [(item.child) ? [_c('el-submenu', {
      attrs: {
        "index": item.url
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(_vm.readMenuItemName))]), _vm._v(" "), _vm._l((item.child), function(childitem) {
      return [_c('el-menu-item', {
        attrs: {
          "index": childitem.url
        }
      }, [_vm._v(_vm._s(childitem.name))])]
    })], 2)] : [_c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_vm._v(_vm._s(item.name))])]]
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 5,
      "lg": 4
    }
  }, [_c('div', {
    staticClass: "toolbar-features"
  }, [_c('el-button', {
    staticClass: "feat-button",
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.handleAddClick
    }
  }, [((_vm.keypath === 'list' || _vm.keypath === 'review') && _vm.type === 'ieditor') ? _c('i', {
    staticClass: "el-icon-plus"
  }) : _vm._e()]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('div', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "iconfont icon-user fs-catego"
  }), _vm._v(" "), _c('span', {
    staticClass: "features-name fs-catego"
  }, [_vm._v(_vm._s(_vm.account))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'press' && _vm.type !== 'stats'),
      expression: "type!=='press'&&type!=='stats'"
    }],
    staticClass: "iconfont icon-menu"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "fs-catego",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'press' && _vm.type !== 'stats'),
      expression: "type!=='press'&&type!=='stats'"
    }]
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "workstats"
    }
  }, [_vm._v("工作统计")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "outLogin",
      "divided": _vm.type !== 'press' && _vm.type !== 'stats'
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports = {"name":"ibroadcast","version":"1.8.3","description":"班玛资讯","author":"LIPan <panlee@qq.com>","private":true,"scripts":{"dev":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","deploy":"fis3 release sbox","analyz":"NODE_ENV=production npm_config_report=true npm run build"},"dependencies":{"crypto-js":"^3.1.8","axios":"^0.15.3","element-ui":"^1.2.3","react-cookie":"^1.0.4","vue":"^2.2.2","vue-router":"^2.2.0","vuex":"^2.2.1","vuex-router-sync":"^4.0.2"},"devDependencies":{"autoprefixer":"^6.7.2","axios-mock-adapter":"^1.7.1","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-loader":"^6.2.10","babel-plugin-istanbul":"^3.1.2","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.2.1","babel-preset-es2015":"^6.22.0","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chai":"^3.5.0","chalk":"^1.1.3","chromedriver":"^2.27.2","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^3.1.4","cross-spawn":"^5.0.1","css-loader":"^0.26.1","eslint":"^3.14.1","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^2.0.1","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.10.0","friendly-errors-webpack-plugin":"^1.1.3","function-bind":"^1.1.0","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","inject-loader":"^2.0.1","karma":"^1.4.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-sinon-chai":"^1.2.4","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.26","karma-webpack":"^2.0.2","lolex":"^1.5.2","mocha":"^3.2.0","mockjs":"^1.0.1-beta3","nightwatch":"^0.9.12","node-sass":"^4.7.2","opn":"^4.0.2","optimize-css-assets-webpack-plugin":"^1.3.0","ora":"^1.1.0","phantomjs-prebuilt":"^2.1.14","rimraf":"^2.6.0","sass-loader":"^6.0.3","selenium-server":"^3.0.1","semver":"^5.3.0","sinon":"^2.1.0","sinon-chai":"^2.8.0","url-loader":"^0.5.7","vconsole":"^3.0.0","vue-loader":"^11.1.4","vue-style-loader":"^2.0.0","vue-template-compiler":"^2.2.4","webpack":"^2.2.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.16.1","webpack-merge":"^2.6.1"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.headerOption = exports.jokeRating = exports.jokeScenario = exports.eventType = exports.searchOptions = exports.routerType = exports.roleTypeId = exports.roleType = exports.auditFullType = exports.auditType = exports.newsPlatformType = exports.newsListAddr = exports.newsPlatform = exports.hotsType = exports.newsType = exports.ACCOUNT = exports.TOKEN = exports.API_HOST = exports.CONSOLE_HOST = exports.MOCK_DEBUG = undefined;

var _assign = __webpack_require__(80);

var _assign2 = _interopRequireDefault(_assign);

exports.setParams = setParams;

var _store = __webpack_require__(70);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOCK_DEBUG = exports.MOCK_DEBUG = false;

var CONSOLE_HOST = exports.CONSOLE_HOST = MOCK_DEBUG === true ? '' : window.location.host === 'localhost:8000' || window.location.host === 'test.guoyi.im' ? '//59.110.240.142:8082' : '//be.banma.jizhuoyangqing.com:8080';
console.debug("config>" + window.location.host);
var API_HOST = exports.API_HOST = MOCK_DEBUG === true ? '' : window.location.host === 'localhost:8000' || window.location.host === 'test.guoyi.im' ? '//59.110.240.142:80' : '//api.banma.jizhuoyangqing.com';
var TOKEN = exports.TOKEN = _store2.default.getters.getToken;
var ACCOUNT = exports.ACCOUNT = _store2.default.getters.getAccount;

var newsType = exports.newsType = {
    "2": "时政",
    "3": "社会",
    "4": "国际",
    "5": "科技",
    "6": "财经",
    "7": "娱乐",
    "8": "体育",
    "9": "军事",
    "10": "时尚"
};

var hotsType = exports.hotsType = {
    "0": "头条",
    "1": "HOT 1",
    "2": "HOT 2",
    "3": "HOT 3",
    "4": "HOT 4",
    "5": "HOT 5",
    "6": "HOT 6",
    "7": "HOT 7"
};

var newsPlatform = exports.newsPlatform = {
    "1": "腾讯新闻",
    "2": "新浪新闻",
    "3": "中新网",
    "4": "凤凰网",
    "5": "人民网",
    "6": "网易新闻",
    "7": "今日头条"
};

var newsListAddr = exports.newsListAddr = [{ "value": "腾讯新闻", "address": "qq.com" }, { "value": "新浪新闻", "address": "sina.com.cn" }, { "value": "中新网", "address": "chinanews.com" }, { "value": "凤凰网", "address": "ifeng.com" }, { "value": "人民网", "address": "people.com.cn/" }, { "value": "网易新闻", "address": "163.com" }, { "value": "今日头条", "address": "toutiao.com" }];

var newsPlatformType = exports.newsPlatformType = {
    "腾讯新闻": "1",
    "百度新闻": "2"
};

var auditType = exports.auditType = {
    "1": "编辑端",
    "2": "录音端",
    "5": "回收站"
};

var auditFullType = exports.auditFullType = {
    "1": "编辑中",
    "2": "录音中",
    "3": "审核中",
    "4": "已发布",
    "5": "回收站"
};

var roleType = exports.roleType = {
    "": "unknown",
    "1": "ieditor",
    "2": "irecord",
    "3": "audit",
    "4": "stats",
    "5": ""
};
var roleTypeId = exports.roleTypeId = {
    "ieditor": "1",
    "irecord": "2",
    "audit": "3",
    "stats": "4",
    "unknown": ""
};

var routerType = exports.routerType = {
    "ieditor": "编辑端",
    "irecord": "录音端",
    "audit": "审核端",
    "press": "班玛",
    "stats": "监控端",
    "joke": "段子"
};

var searchOptions = exports.searchOptions = {
    "标签": "1",
    "标题": "2",
    "内容": "4"
};

var eventType = exports.eventType = {
    "1": "增加新闻",
    "2": "编辑新闻",
    "3": "发布新闻",
    "4": "上传录音",
    "5": "发布录音",
    "6": "审核打回",
    "7": "审核通过"
};

var jokeScenario = exports.jokeScenario = {
    "1": "家庭",
    "2": "情侣",
    "3": "亲子"
};

var jokeRating = exports.jokeRating = {
    "1": "儿童",
    "2": "大众",
    "3": "成人"
};

function setParams(param) {
    var token = {
        token: _store2.default.getters.getToken,
        name: _store2.default.getters.getAccount
    };

    var params = (0, _assign2.default)(token, param);

    return params;
}

var headerOption = exports.headerOption = {
    title: {
        text: '新闻产出分布',
        subtext: '',
        x: 'center',
        align: 'right'
    },
    toolbox: {
        show: true,
        feature: {
            dataZoom: {
                yAxisIndex: 'none'
            },
            dataView: {
                show: true,
                readOnly: false
            },
            magicType: {
                show: false,
                type: ["bar"]
            },
            restore: {
                show: false
            },
            saveAsImage: {
                show: true
            }
        }
    },
    legend: {
        data: ['新闻数量'],
        x: 'left'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            animation: false,
            label: {
                backgroundColor: '#505765'
            }
        }
    },
    dataZoom: {
        show: true,
        realtime: true,
        start: 0 },
    grid: {
        y2: 80
    },
    xAxis: [{
        type: 'time',
        splitNumber: 6
    }],
    yAxis: [{
        name: '数量(条/每小时)',
        type: 'value'
    }],
    series: [{
        name: '新闻数量',
        type: 'line',
        showAllSymbol: true,
        data: null
    }]

};

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(72);

var _vuex2 = _interopRequireDefault(_vuex);

var _logger = __webpack_require__(271);

var _logger2 = _interopRequireDefault(_logger);

var _navmenu = __webpack_require__(166);

var _navmenu2 = _interopRequireDefault(_navmenu);

var _common = __webpack_require__(161);

var _common2 = _interopRequireDefault(_common);

var _login = __webpack_require__(165);

var _login2 = _interopRequireDefault(_login);

var _ieditor = __webpack_require__(162);

var _ieditor2 = _interopRequireDefault(_ieditor);

var _irecord = __webpack_require__(163);

var _irecord2 = _interopRequireDefault(_irecord);

var _press = __webpack_require__(167);

var _press2 = _interopRequireDefault(_press);

var _audit = __webpack_require__(160);

var _audit2 = _interopRequireDefault(_audit);

var _stats = __webpack_require__(168);

var _stats2 = _interopRequireDefault(_stats);

var _joke = __webpack_require__(164);

var _joke2 = _interopRequireDefault(_joke);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var debug = "production" !== 'production';

var store = new _vuex2.default.Store({
    modules: {
        login: _login2.default,
        ieditor: _ieditor2.default,
        irecord: _irecord2.default,
        audit: _audit2.default,
        press: _press2.default,
        stats: _stats2.default,
        navmenu: _navmenu2.default,
        common: _common2.default,
        joke: _joke2.default
    },
    strict: debug,
    plugins: debug ? [(0, _logger2.default)()] : []
});

exports.default = store;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cloneObj = undefined;

var _stringify = __webpack_require__(114);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(29);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.getNowTime = getNowTime;
exports.routeMap = routeMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNowTime(format) {
    var d = new Date(),
        year = d.getFullYear(),
        month = d.getMonth() + 1,
        date = d.getDate(),
        hours = d.getHours(),
        minutes = d.getMinutes(),
        seconds = d.getSeconds();
    if (format !== 'yyyy-mm-dd hh:mm:ss') {
        return year + '-' + month + '-' + date;
    }
    return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
}

function routeMap(url) {
    return '/atlanta' + url;
}

var cloneObj = exports.cloneObj = function cloneObj(obj) {
    var str,
        newobj = obj.constructor === Array ? [] : {};
    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
        return;
    } else if (window.JSON) {
        str = (0, _stringify2.default)(obj), newobj = JSON.parse(str);
    } else {
        for (var i in obj) {
            newobj[i] = (0, _typeof3.default)(obj[i]) === 'object' ? cloneObj(obj[i]) : obj[i];
        }
    }
    return newobj;
};

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds() };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return fmt;
};

/***/ })

},[159]);


// WEBPACK FOOTER //
// static/js/app.ca41040221a6d2fef1c1.js